const KEY = 'dopamine-runner.records.v1';

const EMPTY = { bestScore: 0, bestDistance: 0, bestCoins: 0, totalCoins: 0, runs: 0 };

/**
 * Récords guardados en el dispositivo (localStorage).
 * Si el almacenamiento no está disponible (modo privado, bloqueado…) funciona solo en memoria.
 */
export class Records {
  constructor(storage = globalThis.localStorage) {
    this.storage = storage;
    this.data = { ...EMPTY, ...this.#load() };
  }

  /** Registra una partida terminada. Devuelve true si es un nuevo récord de puntos. */
  submit({ score, distance, coins }) {
    const d = this.data;
    this.previous = { ...d };
    const isNew = score > d.bestScore;
    d.bestScore = Math.max(d.bestScore, score);
    d.bestDistance = Math.max(d.bestDistance, Math.floor(distance));
    d.bestCoins = Math.max(d.bestCoins, coins);
    d.totalCoins += coins;
    d.runs++;
    this.#save();
    return isNew;
  }

  /** Deshace la última partida registrada (al usar la segunda oportunidad, la partida sigue). */
  undoLast() {
    if (!this.previous) return;
    this.data = this.previous;
    this.previous = null;
    this.#save();
  }

  #load() {
    try {
      const raw = this.storage?.getItem(KEY);
      return raw ? JSON.parse(raw) : {};
    } catch {
      return {};
    }
  }

  #save() {
    try {
      this.storage?.setItem(KEY, JSON.stringify(this.data));
    } catch {
      // Sin almacenamiento: el récord dura lo que dure la página.
    }
  }
}
